var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require("@/assets/images/no-data.png"),"alt":""}}),(!_vm.noTxt)?_c('div',{staticClass:"ml-20 color-666"},[_c('p',[_vm._v("抱歉，没有找到相关结果。建议：")]),_c('p',[_vm._v("1、请您尝试简化输入词")]),_c('p',[_vm._v("2、请您尝试减少筛选条件")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }